export default "__VITE_ASSET__eedc184c__"